import { getComponentFromName } from '@folklore/utils';
import classNames from 'classnames';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import SponsorTypo from '../typography/Sponsor';

import styles from '../../styles/partials/sponsor.module.css';

import { ReactComponent as CbcGem } from '../../assets/img/sponsors/cbc_gem.svg';
import { ReactComponent as Crave } from '../../assets/img/sponsors/crave.svg';
import { ReactComponent as Illico } from '../../assets/img/sponsors/illico.svg';
import { ReactComponent as SavoirMedia } from '../../assets/img/sponsors/savoir.svg';
import { ReactComponent as TeleQuebec } from '../../assets/img/sponsors/telequebec.svg';
import { ReactComponent as TouTv } from '../../assets/img/sponsors/toutv.svg';

const Logos = {
    CbcGem,
    Cbc: CbcGem,
    Crave,
    TouTv,
    Illico,
    SavoirMedia,
    Savoir: SavoirMedia,
    TeleQuebec,
};

export interface SponsorProps {
    organisation: Organisation;
    image?: Image | null;
    presentedByLabel?: ReactNode;
    withImage?: boolean;
    withoutPresentedBy?: boolean;
    url?: string | null;
    className?: string | null;
    labelClassName?: string | null;
    imageClassName?: string | null;
}

const Sponsor = ({
    organisation,
    image = null,
    presentedByLabel = null,
    withImage = false,
    withoutPresentedBy = false,
    url = null,
    className = null,
    labelClassName = null,
    imageClassName = null,
}: SponsorProps) => {
    const { name = null } = organisation || {};
    const { url: imageUrl = null } = image || {};
    const ImageComponent =
        name !== null
            ? getComponentFromName(Logos, name.normalize('NFD').replace(/[\u0300-\u036f]/g, '')) ||
              null
            : null;
    const hasImage = image !== null || ImageComponent !== null;
    return name !== null && (!withImage || !hasImage) ? (
        <SponsorTypo className={classNames([styles.container, className || undefined])}>
            {withoutPresentedBy ? (
                name
            ) : (
                <>
                    {presentedByLabel || (
                        <FormattedMessage
                            defaultMessage="Présenté par"
                            description="Sponsor label"
                        />
                    )}{' '}
                    <strong>{name}</strong>
                </>
            )}
        </SponsorTypo>
    ) : (
        <SponsorTypo
            tag={withImage && url !== null ? 'a' : 'div'}
            href={withImage ? url : null}
            target={url !== null ? '_blank' : null}
            className={classNames([
                styles.container,
                {
                    [styles.withImage]: withImage && hasImage,
                    [styles.withoutPresentedBy]: withoutPresentedBy,
                    [styles.link]: url !== null,
                },
                className || undefined,
            ])}
        >
            {!withoutPresentedBy ? (
                <div className={classNames([styles.label, labelClassName])}>
                    {presentedByLabel || (
                        <FormattedMessage
                            defaultMessage="Présenté par"
                            description="Sponsor label"
                        />
                    )}
                </div>
            ) : null}
            {withImage && imageUrl !== null ? (
                <img
                    src={imageUrl}
                    className={classNames([styles.image, imageClassName])}
                    alt={name || 'icon'}
                    title={name || 'icon'}
                />
            ) : null}
            {withImage && imageUrl === null && ImageComponent !== null ? (
                <ImageComponent className={classNames([styles.image, imageClassName])} />
            ) : null}
        </SponsorTypo>
    );
};

export default Sponsor;
